import DuotoneLightIcon from '../common/DuotoneLightIcon';
import './../common/Utils.css';
import { useTranslation } from 'react-i18next';
import { iconButtonStyle } from '../../utils/styles';
import { NavbarButton } from '../Layout/NavbarButton';

const ButtonTableNavbar = ({ type, onClick }) => {
  const { t } = useTranslation();

  const disabled = type !== 'header' && type !== 'cell';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {/* Alignement vertical */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <NavbarButton
          tooltipContent={t('top-alignment')}
          onClick={(e) => onClick({ action: 'verticalAlignment', value: 'top' })}
          disabled={disabled}
          icon={<DuotoneLightIcon name='arrow-down-to-line' style={{ ...iconButtonStyle(), transform: 'rotate(180deg)' }} />}
          className="pop-menu-btn"
        />
        <NavbarButton
          tooltipContent={t('vertical-center-alignment')}
          onClick={(e) => onClick({ action: 'verticalAlignment', value: 'center' })}
          disabled={disabled}
          icon={<DuotoneLightIcon name='arrows-to-line' style={iconButtonStyle()} />}
          className="pop-menu-btn"
        />
        <NavbarButton
          tooltipContent={t('bottom-alignment')}
          onClick={(e) => onClick({ action: 'verticalAlignment', value: 'bottom' })}
          disabled={disabled}
          icon={<DuotoneLightIcon name='arrow-down-to-line' style={iconButtonStyle()} />}
          className="pop-menu-btn"
        />
      </div>
      {/* Alignement horizontal */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <NavbarButton
          tooltipContent={t('left-alignment')}
          onClick={(e) => onClick({ action: 'alignment', value: 'left' })}
          disabled={disabled}
          icon={<DuotoneLightIcon name='align-left' weight='solid' style={iconButtonStyle()} />}
          className="pop-menu-btn"
        />
        <NavbarButton
          tooltipContent={t('center-alignment')}
          onClick={(e) => onClick({ action: 'alignment', value: 'center' })}
          disabled={disabled}
          icon={<DuotoneLightIcon name='align-center' weight='solid' style={iconButtonStyle()} />}
          className="pop-menu-btn"
        />
        <NavbarButton
          tooltipContent={t('right-alignment')}
          onClick={(e) => onClick({ action: 'alignment', value: 'end' })}
          disabled={disabled}
          icon={<DuotoneLightIcon name='align-right' weight='solid' style={iconButtonStyle()} />}
          className="pop-menu-btn"
        />
        <NavbarButton
          tooltipContent={t('justify-alignment')}
          onClick={(e) => onClick({ action: 'alignment', value: 'justify' })}
          disabled={disabled}
          icon={<DuotoneLightIcon name='align-justify' weight='solid' style={iconButtonStyle()} />}
          className="pop-menu-btn"
        />
      </div>
    </div>
  );
};

export default ButtonTableNavbar;
